// 3rd party
import { Injectable } from '@angular/core';
import { Http, HttpModule, Headers, Request, RequestOptions, RequestMethod, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

// components
import { LayoutMainComponent } from '../layout-main.component';

// models
import { ContactCustomer } from 'app/shared/models/contact-customer.model';

// services
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LayoutMainService {

  constructor(
    private http: Http,
    private translate: TranslateService
  ) { }

  changeLanguage(lang: string): Observable<boolean> {
    if (!lang) {
      return;
    }
    const identifier = (JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer).Identifier;
    let body = JSON.stringify({ identifier: identifier, language: lang });
    let options = new RequestOptions();
    options.headers = new Headers({ 'Content-Type': 'application/json' });
    return new Observable<boolean>(obs => {
      this.http
        .put('customers/contacts/language', body, options)
        .subscribe((data) => {
          this.translate.use(lang).subscribe((res) => {
            localStorage.setItem('preferedLang', this.translate.currentLang);
            obs.next(true);
          });
        }, (err) => {
          obs.next(false);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/layout-main/shared/layout-main.service.ts